module.exports = __webpack_public_path__ + "static/media/image13.7b930f0c.JPG";